import type {} from "@lit-labs/react";
import { Button as ButtonElement, } from "@vaadin/button/vaadin-button.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ButtonElement, };
export type ButtonEventMap = Readonly<{}>;
const events = {} as ButtonEventMap;
export type ButtonProps = WebComponentProps<ButtonElement, ButtonEventMap>;
export const Button = createComponent({
    elementClass: ButtonElement, events, react: React, tagName: "vaadin-button"
});
